import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { recoverFromLazyChunkFailure } from './app/core/errors/lazy-chunk-recovery';

window.addEventListener('error', event => {
  recoverFromLazyChunkFailure(event.error ?? event.message);
});

window.addEventListener('unhandledrejection', event => {
  if (recoverFromLazyChunkFailure(event.reason)) {
    event.preventDefault();
  }
});

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
